export default function SidebarFooter() {
  return (
    <div className="sidebar-footer">
      <div className="footer-items">
        <div>
          <strong>CLAS Version:</strong> {__APP_VERSION__}
        </div>
        <div>Cypress Lawn © {new Date().getFullYear()}</div>
      </div>
    </div>
  );
}
